import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TriggerType } from 'client/voladeum/trigger-types/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: TriggerType[] = EMPTY_ARRAY;

export const triggerTypesSlice = createSlice({
  name: SLICE.TRIGGER_TYPES,
  initialState,
  reducers: {
    setTriggerTypes: (_state, action: PayloadAction<TriggerType[]>) => {
      return action.payload;
    },
    clearTriggerTypes: () => {
      return initialState;
    },
  },
});

export const { setTriggerTypes, clearTriggerTypes } = triggerTypesSlice.actions;

export default triggerTypesSlice.reducer;
